/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
import { FaIcon } from "lib/FaIcon";

export const Expandable = ({
  label,
  defaultValue,
  children,
  className = "ml-sm-3 mb-sm-2",
  labelClasses = "",
  isDesktop = true,
}) => {
  const [isOpen, setOpen] = useState(defaultValue);
  const iconClassName = isOpen ? "fa-chevron-up" : "fa-chevron-down";
  const labelClassName = isOpen ? "font-weight-bold " : "";
  if (!label) return children;

  return (
    <>
      <a onClick={() => setOpen(!isOpen)} href="#/" className={labelClassName + "cursor-pointer " + labelClasses}>
        {isDesktop ? (isOpen ? "- " : "+ ") : ""}
        {label}
        {!isDesktop && <FaIcon icon={"fas ml-auto mr-1 " + iconClassName} />}
      </a>

      <Collapse in={isOpen} className={className}>
        <section>{isOpen && children}</section>
      </Collapse>
    </>
  );
};

export const MExpandable = (props) => <Expandable {...props} isDesktop={false} />;
